import { render, staticRenderFns } from "./LegalSearch.vue?vue&type=template&id=5d745642&scoped=true"
import script from "./LegalSearch.vue?vue&type=script&lang=ts"
export * from "./LegalSearch.vue?vue&type=script&lang=ts"
import style0 from "./LegalSearch.vue?vue&type=style&index=0&id=5d745642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d745642",
  null
  
)

export default component.exports